import { Oval } from "react-loader-spinner"
import { BaseProps } from "react-loader-spinner/dist/type"

interface LoaderProps extends BaseProps {
  strokeWidth?: string | number;
  strokeWidthSecondary?: string | number;
  secondaryColor?: string;
  className?: string;
}

export const Loader = ({
  height = 30,
  width = 30,
  color = "#7f7f7f",
  secondaryColor = "#1C212D",
  strokeWidth = 2,
  strokeWidthSecondary = 2,
  visible = true,
  ariaLabel = "oval-loading",
  wrapperStyle,
  className,
}: LoaderProps) => {
  return (
    <Oval
      height={height}
      width={width}
      color={color}
      secondaryColor={secondaryColor}
      strokeWidth={strokeWidth}
      strokeWidthSecondary={strokeWidthSecondary}
      visible={visible}
      ariaLabel={ariaLabel}
      wrapperStyle={wrapperStyle}
      wrapperClass={className}
    />
  );
};